

























































































































































import Vue from "vue";
import { authentication, DocData } from "@/stores";
import { Route } from "vue-router";
import {
  TenantNews,
  TenantEvent,
  TenantOrder,
  EventCounter,
  NewsAccessCounter,
  Tenant,
  Coupon,
  MobileCoupon,
  getAccessCountListWithData,
  getFollowListWithData,
  getFavoriteListWithData,
  Splash
} from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import dayjs from "dayjs";
import axios from "axios";

const db = firebaseProject.firestore();

export default Vue.extend({
  name: "Top",
  mixins: [shopBase],
  async created() {
    const tenantIds = await (
      await db
        .collection("tenant")
        .where("shopId", "==", this.$config.shopId)
        .get()
    ).docs.map(item => item.id);

    const lastdayKey = dayjs().format("YYYYMMDD");
    const lastdayData = await db
      .collection(`/shop/${this.$config.shopId}/userCounts`)
      .doc(lastdayKey)
      .get();
    if (lastdayData.exists) {
      this.lastdayDAU = lastdayData?.data()?.yesterdayDAU as number;
      this.lastdayTotalUserCount = lastdayData?.data()
        ?.selectedUserCount as number;
      const lastday2Key = dayjs()
        .add(-1, "day")
        .format("YYYYMMDD");
      const lastday2Data = await db
        .collection(`/shop/${this.$config.shopId}/userCounts`)
        .doc(lastday2Key)
        .get();
      if (lastday2Data.exists) {
        this.lastdayUserCount = (this.lastdayTotalUserCount -
          lastday2Data?.data()?.selectedUserCount) as number;
      }
    }

    /*
    new List<Splash>(db.collectionGroup("splash") as firestore.Query<Splash>)
      .query({
        filter: {
          authorizeStatus: { $eq: 1 }
        },
        orderBy: [
          {
            field: "createTime",
            order: "desc"
          }
        ]
      })
      .ref?.get()
      .then(snapshot => {
        this.topSplashsPendingApproval = snapshot.docs
          .map(doc => {
            return new DocDataRef({
              document: doc.data() as Splash,
              id: doc.id,
              ref: doc.ref
            } as DocData<Splash>);
          })
          .filter(item => {
            return (
              item &&
              item?.data?.tenantId &&
              tenantIds.indexOf(item?.data?.tenantId!) != -1
            );
          });
        this.countSplashsPendingApproval = this.topSplashsPendingApproval?.length;
      });
    */

    const functions = firebaseProject.functions("asia-northeast1");
    const callableNews = functions.httpsCallable("consoleNews");
    callableNews({
      shopId: this.$config.shopId,
      authorizeStatus: 1
    })
      .then(res => {
        if (res && res.data.status == "SUCCEED") {
          this.topNewsPendingApproval = res.data.news;
          this.countNewsPendingApproval = res.data.maxNumber;
        }
      })
      .catch(e => {
        console.error(e);
      });

    const callableEvent = functions.httpsCallable("consoleEvent");
    callableEvent({
      shopId: this.$config.shopId,
      authorizeStatus: 1
    })
      .then(res => {
        if (res && res.data.status == "SUCCEED") {
          this.topEventsPendingApproval = res.data.event;
          this.countEventsPendingApproval = res.data.maxNumber;
        }
      })
      .catch(e => {
        console.error(e);
      });

    const callableCoupon = functions.httpsCallable("consoleCoupon");
    callableCoupon({
      shopId: this.$config.shopId,
      authorizeStatus: 1
    })
      .then(res => {
        if (res && res.data.status == "SUCCEED") {
          this.topCouponsPendingApproval = res.data.coupon;
          this.countCouponsPendingApproval = res.data.maxNumber;
        }
      })
      .catch(e => {
        console.error(e);
      });

    /*
    new List<MobileCoupon>(
      db.collectionGroup("mobileCoupon") as firestore.Query<MobileCoupon>
    )
      .query({
        filter: {
          authorizeStatus: { $eq: 1 }
        },
        orderBy: [
          {
            field: "createTime",
            order: "desc"
          }
        ]
      })
      .ref?.get()
      .then(snapshot => {
        this.topMobileCouponsPendingApproval = snapshot.docs
          .map(doc => {
            return new DocDataRef({
              document: doc.data() as MobileCoupon,
              id: doc.id,
              ref: doc.ref
            } as DocData<MobileCoupon>);
          })
          .filter(item => {
            return (
              item &&
              item?.data?.tenantId &&
              tenantIds.indexOf(item?.data?.tenantId!) != -1
            );
          });
        this.countMobileCouponsPendingApproval = this.topMobileCouponsPendingApproval?.length;
      });
    */

    const nowH = parseInt(dayjs().format("H"));
    let todayD = dayjs();
    if (nowH <= 4) {
      todayD = dayjs().add(-1, "day");
    }

    const todayStart = todayD.startOf("day").valueOf();
    const lastdayStart = todayD
      .startOf("day")
      .add(-1, "day")
      .valueOf();

    const todayOrders = await db
      .collectionGroup("order")
      .where("aeonRegiPaymentRequestTime", ">=", todayStart)
      .where("status", "in", [
        "ORDER_SUCCEED",
        "PREPARING",
        "PREPARED",
        "COMPLETED"
      ])
      .get();
    const todayRevenue = todayOrders.docs
      .filter(item => {
        return (
          item &&
          item.ref.parent.parent?.id &&
          tenantIds.indexOf(item.ref.parent.parent?.id) != -1
        );
      })
      .map(item => {
        return (item?.data() as TenantOrder)?.priceAmount || 0;
      })
      .reduce((p, c, index, list) => {
        return p + c;
      }, 0);
    this.todayRevenue = todayRevenue;

    const lastdayOrders = await db
      .collectionGroup("order")
      .where("aeonRegiPaymentRequestTime", ">=", lastdayStart)
      .where("aeonRegiPaymentRequestTime", "<", todayStart)
      .where("status", "in", [
        "ORDER_SUCCEED",
        "PREPARING",
        "PREPARED",
        "COMPLETED"
      ])
      .get();
    const lastdayRevenue =
      lastdayOrders.docs
        .filter(item => {
          return (
            item &&
            item.ref.parent.parent?.id &&
            tenantIds.indexOf(item.ref.parent.parent?.id) != -1
          );
        })
        ?.map(item => (item.data() as TenantOrder)?.priceAmount)
        ?.reduce((p, c, index, list) => {
          return p + c;
        }, 0) || 0;
    this.lastdayRevenue = lastdayRevenue;

    const lastday = todayD.add(-1, "d").format("YYYYMMDD");
    const last2day = todayD.add(-2, "d").format("YYYYMMDD");
    const today = todayD.format("YYYYMMDD");
    const idToken = await firebaseProject.auth().currentUser?.getIdToken();
    const baseHost = "/api";
    const newsData: any[] = [];
    const getAllNews = async (page: number) => {
      console.log("getAllNews", page);
      const parPage = 8000;
      const resData = await callableNews({
        shopId: this.$config.shopId,
        parPage: parPage,
        currentPage: page,
        simple: 1
      })
        .then(res => {
          if (res && res.data.status == "SUCCEED") {
            console.log("getAllNews", res.data);
            return res.data;
          }
        })
        .catch(e => {
          console.error(e);
        });
      for (const news of resData.news) {
        newsData.push({
          id: news.id,
          data: news
        });
      }
      const maxPage = Math.ceil(resData.maxNumber / parPage);
      if (maxPage > page) {
        await getAllNews(page + 1);
      }
    };
    await getAllNews(1);
    const tenantData = await db
      .collection("tenant")
      .where("shopId", "==", this.$config.shopId)
      .get()
      .then(snapshot => {
        return snapshot.docs.map(doc => {
          return new DocDataRef({
            document: doc.data() as Tenant,
            id: doc.id,
            ref: doc.ref
          } as DocData<Tenant>);
        });
      });
    if (idToken) {
      const accessUrl = baseHost + `/analytics/access`;
      const accessDataLastDay = await axios.get(accessUrl, {
        headers: { Authorization: idToken },
        params: {
          shopId: this.$config.shopId,
          eventStart: lastday,
          eventEnd: lastday
        }
      });
      const accessDataLast2Day = await axios.get(accessUrl, {
        headers: { Authorization: idToken },
        params: {
          shopId: this.$config.shopId,
          eventStart: last2day,
          eventEnd: last2day
        }
      });
      const eventUrl = baseHost + `/analytics/event`;
      const discloseAt =
        this.$config.shop && this.$config.shop.data?.discloseAt;
      const alldayStart = discloseAt
        ? dayjs(discloseAt).format("YYYY-MM-DD")
        : "2020-11-18";
      console.log(`alldayStart: ${alldayStart}`);
      const eventDataAllday = await axios.get(eventUrl, {
        headers: { Authorization: idToken },
        params: {
          shopId: this.$config.shopId,
          eventStart: dayjs(alldayStart).format("YYYYMMDD"),
          eventEnd: lastday
        }
      });
      const accessRankingLastDay = getAccessCountListWithData(
        accessDataLastDay.data.countData as NewsAccessCounter[],
        newsData || []
      );
      const accessRankingLast2Day = getAccessCountListWithData(
        accessDataLast2Day.data.countData as NewsAccessCounter[],
        newsData || []
      );
      const followRanking = getFollowListWithData(
        eventDataAllday.data.countData as EventCounter[],
        tenantData || []
      );
      const favoriteRanking = getFavoriteListWithData(
        eventDataAllday.data.countData as EventCounter[],
        newsData || [],
        tenantData || []
      );
      this.lastdayAccess = accessRankingLastDay?.reduce((p, c) => {
        return p + c.pageview;
      }, 0);
      this.last2dayAccess = accessRankingLast2Day?.reduce((p, c) => {
        return p + c.pageview;
      }, 0);
      this.totalFollows = followRanking?.reduce((p, c) => {
        return p + c.count;
      }, 0);
      this.totalFavorites = favoriteRanking.reduce((p, c) => {
        return p + c.count;
      }, 0);
    }
  },
  data(): {
    authentication: object;
    transitionName: string;
    //countSplashsPendingApproval: number;
    //topSplashsPendingApproval: DocDataRef<Splash>[] | undefined;
    countNewsPendingApproval: number;
    topNewsPendingApproval:
      | firestore.DocumentSnapshot<TenantNews>[]
      | undefined;
    countEventsPendingApproval: number;
    topEventsPendingApproval:
      | firestore.DocumentSnapshot<TenantEvent>[]
      | undefined;
    countCouponsPendingApproval: number;
    topCouponsPendingApproval: DocDataRef<Coupon>[] | undefined;
    //countMobileCouponsPendingApproval: number;
    //topMobileCouponsPendingApproval: DocDataRef<MobileCoupon>[] | undefined;
    todayRevenue: number;
    lastdayRevenue: number;
    totalFollows: number;
    totalFavorites: number;
    lastdayAccess: number;
    last2dayAccess: number;
    lastdayDAU: number | string;
    lastdayUserCount: number | string;
    lastdayTotalUserCount: number | string;
  } {
    return {
      authentication,
      transitionName: "",
      //countSplashsPendingApproval: 0,
      //topSplashsPendingApproval: undefined,
      countNewsPendingApproval: 0,
      topNewsPendingApproval: undefined,
      countEventsPendingApproval: 0,
      topEventsPendingApproval: undefined,
      countCouponsPendingApproval: 0,
      topCouponsPendingApproval: undefined,
      //countMobileCouponsPendingApproval: 0,
      //topMobileCouponsPendingApproval: undefined,
      todayRevenue: 0,
      lastdayRevenue: 0,
      totalFollows: 0,
      totalFavorites: 0,
      lastdayAccess: 0,
      last2dayAccess: 0,
      lastdayDAU: "-",
      lastdayUserCount: "-",
      lastdayTotalUserCount: "-"
    };
  },
  watch: {}
});
